module.exports = __webpack_public_path__ + "static/media/example-1.8e031141.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/CCIWA/example-1.jpg
// module id = 218
// module chunks = 0